import { useState } from 'react';

const faqItems = [
  {
    q: '桃花视频完全免费吗？需要付费才能观看吗？',
    a: '桃花视频所有内容完全免费观看，聚合红桃视频、樱桃视频、茄子视频、糖心视频等平台公开资源，无需充值、无需会员，打开即看。我们通过广告合作维持运营，绝不会向用户收取任何费用。',
  },
  {
    q: '观看视频需要注册账号吗？是否必须登录？',
    a: '不需要注册账号，也不需要登录。桃花视频倡导便捷观影体验，用户无需提供任何个人信息即可直接浏览和观看所有影视内容，真正做到即开即看。',
  },
  {
    q: '支持哪些设备观看？画质怎么样？',
    a: '桃花视频全面支持电脑、平板和手机浏览器访问，适配 iOS、Android、Windows、macOS 等主流系统。所有视频提供高清画质，服务器采用智能 CDN 加速，确保播放流畅不缓冲。',
  },
  {
    q: '视频资源更新频率如何？能第一时间看到最新剧集吗？',
    a: '我们每日 24 小时不间断更新内容，电视剧、综艺、动漫等热门内容在首播后数小时内即可同步上线。电影资源也会在院线热映期结束后第一时间收录，让你追剧永不落后。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[800px] mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-2">常见问题</h2>
        <p className="text-sm text-foreground-400 text-center mb-8 md:mb-10">关于桃花视频，你可能想了解的一切</p>
        <div className="flex flex-col gap-3">
          {faqItems.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-lg overflow-hidden">
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
              >
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">{item.q}</h3>
                <span className={`flex-shrink-0 w-6 h-6 rounded-full bg-background-200 flex items-center justify-center transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-sm"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-[300px] pb-4 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}